export default {
  graphicriverFileTypesOnItemCard: 'lO-xXQlvR8GVdUK_xuHt4Q',
  codecanyonItemAttributes: 'J1Rs6z7-R660nbA7Bmsy3A'
}
